module.exports = __webpack_public_path__ + "img/39_42.22988df7.png";